(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["f47-prewire-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('f47-prewire-finder')) {
  customElements.define('f47-prewire-finder', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const yearField = document.querySelector('select[id="easysearch_field_26042"]');
        const modelField = document.querySelector('select[id="easysearch_field_33691"]');
        const selectedYear = Number(yearField?.value);
        const selectedModel = (modelField?.selectedOptions[0]?.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
        const vehicle = selectedYear && selectedModel && selectedModel !== 'model' ? { year: selectedYear, modelKey: selectedModel } : window.F47Garage?.readActiveVehicle();
        const models = JSON.parse(this.dataset.models);
        const eligible = vehicle ? Number(vehicle.year) >= 2024 && (models.includes(vehicle.modelKey) || /^road king\b/.test(vehicle.modelKey) && Number(vehicle.year) >= 2026) : this.dataset.collectionEligible === 'true';
        this.hidden = !eligible;
      };
      this.update();
      this.onChange = event => {
        if (event.target.matches('select[id^="easysearch_field_"]')) this.update();
      };
      document.addEventListener('change', this.onChange);
      const filterHost = document.querySelector('select[id="easysearch_field_26042"]')?.closest('[id^="shopify-block-"]');
      if (filterHost) {
        this.observer = new MutationObserver(this.update);
        this.observer.observe(filterHost, { childList: true, subtree: true });
      }
      window.addEventListener('storage', this.update);
      window.addEventListener('pageshow', this.update);
      document.addEventListener('DOMContentLoaded', this.update, { once: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('change', this.onChange);
      window.removeEventListener('storage', this.update);
      window.removeEventListener('pageshow', this.update);
      document.removeEventListener('DOMContentLoaded', this.update);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["f47-prewire-option"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('f47-prewire-option')) {
  customElements.define('f47-prewire-option', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.check = this.querySelector('[data-prewire-check]');
      if (!this.check) return;
      this.fields = this.querySelector('[data-prewire-fields]');
      this.year = this.querySelector('[data-prewire-year]');
      this.model = this.querySelector('[data-prewire-model]');
      this.addEventListener('change', () => this.sync());
      this.year.addEventListener('input', () => this.sync());
      this.sync();
    }
    sync() {
      this.fields.hidden = !this.check.checked;
      this.fields.disabled = !this.check.checked;
      this.model.setCustomValidity(this.check.checked && this.model.value === 'Road King' && Number(this.year.value) < 2026 ? this.dataset.error : '');
      this.closest('form')?.querySelectorAll('.shopify-payment-button, [data-sticky-express]').forEach(el => {
        if (this.check.checked) {
          if (!el.hasAttribute('data-prewire-hidden')) {
            el.dataset.prewireHidden = el.style.display;
            el.style.display = 'none';
          }
        } else if (el.hasAttribute('data-prewire-hidden')) {
          el.style.display = el.dataset.prewireHidden;
          delete el.dataset.prewireHidden;
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
